import { useCallback, useState } from "react";
import useDefaultErrorWrapper from "../../../../shared/hooks/useDefaultErrorWrapper";
import useFirebaseAppFunction from "../../../../shared/hooks/useFirebaseAppFunction";
import { AuthConfirmUserFormProps } from "../AuthConfirmUserForm";
import useErrorMessages from "./useErrorMessages";

const useResendCode = (params: {
  email: string;
  phoneType?: "primary" | "additional";
  handleError: (msg: string | null) => void;
}) => {
  const { email, phoneType, handleError } = params;

  const [isLoading, setIsLoading] = useState(false);

  const { getErrorMessageOnResendCode } = useErrorMessages();

  const { runAsyncFunction } = useDefaultErrorWrapper();

  const sendCustomerPortalAuthCode = useFirebaseAppFunction(
    "sendCustomerPortalAuthCode",
  );

  const handleResend = useCallback<
    AuthConfirmUserFormProps["handleResend"]
  >(async () => {
    try {
      handleError(null);
      setIsLoading(true);
      const { data } = await runAsyncFunction(sendCustomerPortalAuthCode, {
        email,
        phoneType,
      });

      if (data.status === "error") {
        const msg = getErrorMessageOnResendCode(data.error.code);
        throw new Error(msg);
      }
    } catch (error) {
      handleError((error as Error).message);
    } finally {
      setIsLoading(false);
    }
  }, [
    handleError,
    runAsyncFunction,
    sendCustomerPortalAuthCode,
    email,
    phoneType,
    getErrorMessageOnResendCode,
  ]);

  return { handleResend, isLoading };
};

export default useResendCode;
